import { gql } from '@apollo/client';
import { genericItemFieldsFragment } from './index';

export const agencyItemsFragment = gql`
  fragment agencyItemFields on Item {
    ...GenericItemFields
    hasInternalLoan
    photos(limit: 1) {
      thumbnail
      f460x345
    }
  }
  ${genericItemFieldsFragment}
`;
